import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentUserAPI } from '~entities/users/api/get-current-user';

import { SetPasswordPage } from '~pages/set-password/index';

import { QUERY_KEYS } from '~shared/api/query-keys';

export const Route = createFileRoute('/_auth/set-password')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const currentUser = await queryClient.fetchQuery({
      queryKey: QUERY_KEYS.CURRENT_USER(),
      queryFn: getCurrentUserAPI,
    });

    // Agency Admins bypass password setup, so redirect them to dashboard
    if (!currentUser.noPassword || currentUser.isAgencyAdmin) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/dashboard',
      });
    }
  },
  component: SetPasswordPage,
});
